exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  overflow: auto; }\n\n.success-message {\n  color: darkgreen;\n  font-weight: bold; }\n\n.card-box {\n  margin: auto;\n  max-width: 500px;\n  width: 100%; }\n\n.card-header img {\n  height: 20px;\n  margin-right: 10px; }\n\n.version-label {\n  font-size: 90%;\n  color: #606060;\n  padding-top: 10px; }\n\n.mobile-logo {\n  max-height: 60px;\n  max-width: 100%;\n  margin: auto;\n  padding-bottom: 5px; }\n\n.validator-icons {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: initial; }\n\n.validator-section {\n  margin-top: 1em;\n  font-size: 0.9em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/auth/password-reset/password-reset.component.scss
// module id = ../../../../../angular/app/auth/password-reset/password-reset.component.scss
// module chunks = main